import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useProduct } from '~/composables/_next/useProduct';
import { useLocalization } from '~/composables/_next/useLocalization';
export var getPagePrefix = function getPagePrefix(contentType, locale) {
  switch (contentType) {
    case 'pageRecipeList':
      return 'recipes';
    case 'pageGenericCategory':
      return 'category';
    case 'pageRecipe':
      return 'recipe';
    case 'pageAdvice':
      return 'page';
    case 'pageAdviceListing':
      return 'pages';
    case 'pageProductInformationsListingPage':
      return '';
    case 'pageProductListingPage':
      return 'products';
    case 'pageBasic':
      return 'content';
    case 'pageAllProduct':
      return '';
    case 'pageProduct':
      return locale === 'fr' ? 'info/fiche-technique' : 'product';
    case 'pageProductInformations':
      return locale === 'fr' ? 'info/fiche-technique' : 'guide';
    default:
      return false;
  }
};
export default function (_ref) {
  var contentType = _ref.contentType,
    internalLinkObj = _ref.internalLinkObj;
  var productSku = computed(function () {
    var _internalLinkObj$valu, _internalLinkObj$valu2;
    return (_internalLinkObj$valu = internalLinkObj.value) === null || _internalLinkObj$valu === void 0 ? void 0 : (_internalLinkObj$valu2 = _internalLinkObj$valu.fields) === null || _internalLinkObj$valu2 === void 0 ? void 0 : _internalLinkObj$valu2.productSku;
  });
  var _useProduct = useProduct("useInternalLink-getProductBySku"),
    products = _useProduct.products,
    search = _useProduct.search;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    defaultLocale = _useLocalization.defaultLocale;
  var slug = computed(function () {
    var _products$value, _products$value$, _internalLinkObj$valu3;
    switch (contentType.value) {
      case 'pageProduct':
        return (_products$value = products.value) === null || _products$value === void 0 ? void 0 : (_products$value$ = _products$value[0]) === null || _products$value$ === void 0 ? void 0 : _products$value$._slug;
      default:
        return (_internalLinkObj$valu3 = internalLinkObj.value) === null || _internalLinkObj$valu3 === void 0 ? void 0 : _internalLinkObj$valu3.fields.slug;
    }
  });
  var internalLinkLocale = computed(function () {
    var _internalLinkObj$valu4, _internalLinkObj$valu5;
    return (_internalLinkObj$valu4 = internalLinkObj.value) === null || _internalLinkObj$valu4 === void 0 ? void 0 : (_internalLinkObj$valu5 = _internalLinkObj$valu4.sys) === null || _internalLinkObj$valu5 === void 0 ? void 0 : _internalLinkObj$valu5.locale;
  });
  var internalLink = computed(function () {
    var linkArray = [];

    // link localePrefix
    if (locale !== defaultLocale) {
      linkArray.push(internalLinkLocale.value);
    }

    // link pagePrefix
    if (getPagePrefix(contentType.value, internalLinkLocale.value)) {
      linkArray.push(getPagePrefix(contentType.value, internalLinkLocale.value));
    }

    // link slug
    if (slug.value) {
      linkArray.push(slug.value);
    }
    if (linkArray.length > 0) {
      return "/".concat(linkArray.join('/'));
    }
  });
  useLazyAsyncData('composable-useInternalLink', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!productSku.value) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return search({
            skus: [productSku.value]
          });
        case 3:
          return _context.abrupt("return", true);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  watchEffect(function () {
    if (productSku.value) {
      search({
        skus: [productSku.value]
      });
    }
  });
  return {
    internalLink: internalLink
  };
}